<template>
  <div class="Reports__View">
    <EntityListLayout :tabs="tabs" ref="entity" @onNewEntitySave="onNewEntitySave">
      <template #title>משתמשים בקורס</template>
      <template #button>
        <a @click="addUser" class="link-button">
          משתמש חדש
        </a>
      </template>
      <template v-slot:counter="slotProps">
        סה"כ <b>{{ getTotalRecords(slotProps) }} </b>
      </template>
    </EntityListLayout>
  </div>
</template>
<script>
import CoursesService from "@/services/CoursesService";
import LessonService from "@/services/LessonService";
import EntityListLayout from "@/components/EntityListLayout.vue";
import UserEntity from "@/views/UserEntity.vue";
import DialogAddUser from '@/components/DialogAddUser.vue';
import DialogBulkPlannedSchedule from '@/components/DialogBulkPlannedSchedule.vue';
import {
  ModalProgrammatic as Modal,
} from 'buefy';
import FieldService from "@/services/FieldService";
import FilterService from "@/services/FilterService";

export default {
  name: "AdminSearchReports",
  data() {
    return {
      tabs: [],
      escortGroupIds: null,
    };
  },
  components: {
    EntityListLayout,
  },
  computed: {
    isEscort() {
      return this.$store.state.auth.role === "escort";
    },
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      const reportsFields = FieldService.list("users");
      const reportsfilters = FilterService.list();

      const sideViewEntity = {
        component: UserEntity,
        preview: true,
        readOnly: false,
        title: "פרטי איש קשר",
        recordUrl: "user",
      };

      const excelExport = [
        {
          title: "יצוא טבלה",
          action: this.export,
        },
        {
          title: 'הורד JSON שנשלח עבור רשימת משתמשים',
          action: () => this.openBulkScheduleDialog('sent'),
        },
        {
          title: 'הורד JSON שהתקבל עבור רשימת משתמשים',
          action: () => this.openBulkScheduleDialog('received'),
        },
      ];
      const fields = [
        { ...reportsFields.Id, checked: true },
        { ...reportsFields.PrivateName, checked: true },
        { ...reportsFields.LastName, checked: true },
        { ...reportsFields.UserName, checked: true },
        { ...reportsFields.Phone, checked: true },
        { ...reportsFields.Address, checked: true },
        { ...reportsFields.Status, checked: true },
        { ...reportsFields.CreateDate, checked: true },
        { ...reportsFields.UserTypeId, checked: true },
        { ...reportsFields.Entity, checked: true },
      ];

      this.tabs = [
        {
          id: "AllCourseUsers",
          title: "כל המשתמשים",
          getDataAsync: this.getAllUsers,
          perPage: 100,
          fields,
          filters: [
            { ...reportsfilters.Groups, selected: this.$route.params.GroupIds },
          ],
          sortField: "LastPayDate",
          sortOrder: "desc",
          checkableRows: false,
          excelExport,
          fastSearch: true,
          fastSearchOptions: {
            propName: "Terms",
            label: "חיפוש משתמש",
          },
          sideViewEntity,
          tableActions: null,
          isAdminArea: true,
          defaultQuery: false
        },
      ];
    },
    onNewEntitySave() {
      this.$refs.entity.getData(this.tabs[0])
    },
    export({ loading, query }) {
      loading(true);
      CoursesService.exportUsers(this.$store.state.auth.course?.id, query)
        .then((r) => {
          this.saveFile(r.data, "יצוא משתמשים ממערכת SimAdmin");
        })
        .finally(() => {
          loading(false);
        });
    },
    async getAllUsers({ cancelToken, ...rest }) {
      const courseId = this.$store.state.auth.course?.id;
      const query = { ...rest };

      // Escorts can't list all course users; scope to their groups by default.
      if (this.isEscort && !(query.GroupIds && query.GroupIds.length)) {
        const groupIds = await this.getEscortGroupIds(courseId);
        if (groupIds.length) {
          query.GroupIds = groupIds;
        }
      }

      return CoursesService.getUsersByCourse(
        courseId,
        query,
        cancelToken.token
      ).then((r) => ({
        data: {
          TotalResults: r.data.totalResults,
          Items: r.data.items,
        },
      }));
    },
    getEscortGroupIds(courseId) {
      if (this.escortGroupIds) {
        return Promise.resolve(this.escortGroupIds);
      }
      return LessonService.getGroups(courseId, { PageSize: 9999, PageNumber: 1 })
        .then((r) => {
          this.escortGroupIds = (r.data.items || []).map((g) => g.id);
          return this.escortGroupIds;
        })
        .catch(() => []);
    },
    getTotalRecords(slotProps) {
      return slotProps.tab && slotProps.tab.total && slotProps.tab.total;
    },
    saveFile(data, filename) {
      const blob = new Blob([data], { type: this.excelMimeType });
      saveAs(blob, `${filename}.xlsx`);
    },
    loadUsers() {
      this.$refs.entity.getData(this.tabs[0]);
    },
    openBulkScheduleDialog(kind) {
      Modal.open({
        component: DialogBulkPlannedSchedule,
        props: { kind, defaultCourseId: this.$store.state.auth.course?.id || null },
        hasModalCard: true,
        trapFocus: true,
      });
    },
    addUser() {
      Modal.open({
        component: DialogAddUser,
        props: {
          store: this.$store,
          onSuccess: this.onNewEntitySave
        },
        events: {
          customEvent: () => {
            this.loadUsers();
          }
        },
        canCancel: false,
        hasModalCard: true,
        trapFocus: true,
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.Reports__View {
  height: 100%;

  .link-button {
    background: #00427e;
    border: none;
    border-radius: 3px;
    padding: 14px 25px;
    margin-left: 10px;
    color: white;
    cursor: pointer;
  }
}
</style>
